import {Component, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {_GlobalConstants} from '../../../services/globalConstants.service';
import {_ReferenceDataService} from "../../../services/referenceData.service";
import {Observable} from "rxjs/Observable";

declare var jQuery:any;
declare var $ :any;

declare var defaultGridViewSettings;
@Component({
  selector: 'hedge-trades',
  templateUrl: './hedge-trades.component.html',
  styleUrls: ['./hedge-trades.component.css'],
})

export class HedgeTradesBranch implements OnInit, OnDestroy {

  private subscription: any;
  private globalConstants: any;
  private accounts: any;
  private liquidityProviders: any;

  constructor (private titleService: Title, private constants: _GlobalConstants, private referenceData: _ReferenceDataService) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Hedge Broker Positions");
    this.subscription = Observable.forkJoin(this.constants.getGlobalConstants(),
                        this.referenceData.getAccounts(),
                        this.referenceData.getLiquidityProviders()).subscribe((res:Array<any>) => {
      this.globalConstants = res[0];
      this.accounts = res[1];
      this.liquidityProviders = res[2];
      this.ready();
    });
  }

  ready() {
      var source = {
          datatype : 'json',
          datafields : [{
              name : 'positionId',
              type : 'string'
          }, {
              name : 'accountId'
          }, {
              name: 'accountCode',
              type: 'string',
              value: 'accountId',
              values: {
                source: this.accounts,
                value: 'accountId',
                name: 'code'
              }
          }, {
              name : 'liquidityProviderId',
              type : 'string'
          }, {
              name : 'targetCurrency',
              type : 'string'
          }, {
              name : 'counterCurrency',
              type : 'string'
          }, {
              name : 'settlementDate',
              type : 'date',
              format : 'yyyy-MM-dd'
          }, {
            name : 'liquidityProviderDisplay',
            type : 'string',
            value: 'liquidityProviderId',
            values: {
              source: this.liquidityProviders,
              value: 'liquidityProviderId',
              name: 'displayName'
            }
          }, {
              name : 'targetExecutedQuantity',
              type : 'string'
          }, {
              name : 'targetPendingQuantity',
              type : 'string'
          }, {
              name : 'counterExecutedQuantity',
              type : 'string'
          }, {
              name : 'counterPendingQuantity',
              type : 'string'
          }],
          id : 'updateId',
          url : '/ajax/hedging/positions',
          type : 'GET',
          async : false
      };

      var settings = defaultGridViewSettings("#jqxGrid", source);

      settings.columns = [{
          text : 'Account',
          columntype : 'textbox',
          datafield : 'accountCode',
          width : '100'
      }, {
          text : 'Broker',
          columntype : 'textbox',
          datafield : 'liquidityProviderDisplay',
          width : '130'
      }, {
          text : ' Target Ccy',
          columntype : 'textbox',
          datafield : 'targetCurrency',
          width : '80'
      }, {
          text : 'Counter Ccy',
          columntype : 'textbox',
          datafield : 'counterCurrency',
          width : '80'
      }, {
          text : 'Settlement Date',
          columntype : 'datetimeinput',
          datafield : 'settlementDate',
          cellsformat : 'yyyy-MMM-dd',
          width : '90'
      }, {
          text : ' Target Executed Quantity',
          columntype : 'textbox',
          datafield : 'targetExecutedQuantity',
          width : '90'
      }, {
          text : 'Counter Executed Quantity',
          columntype : 'textbox',
          datafield : 'counterExecutedQuantity',
          width : '90'
      }, {
          text : ' Target Pending Quantity',
          columntype : 'textbox',
          datafield : 'targetPendingQuantity',
          width : '90'
      }, {
          text : 'Counter Pending Quantity',
          columntype : 'textbox',
          datafield : 'counterPendingQuantity',
          width : '90'
      }];

      $("#jqxGrid").jqxGrid(settings);

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/orders/hedge-trades/hedge-trades.component.ts